export const getUuidFromUrl = (): string | null => {
  if (typeof window === "undefined") return null;

  const match = window.location.pathname.match(/^\/(shop|sold)\/([^/?#]+)$/);
  return match ? match[2] : null;
};

export const normalizeQuotes = (str: string) =>
  str.replace(/[“”]/g, '"').replace(/[‘’]/g, "'");

export const normalizeQuery = (query: string) => normalizeQuotes(query);
